'use client'

import { Icon, IconComponent } from '@graftcode/design-system'

import { HELP_DRAWER_TEST_IDS } from '@common/common-test-ids.const'
import type { ShareFeedbackPhase } from '@common/components/ShareFeedback'
import { ShareFeedbackContent } from '@common/components/ShareFeedback'

import { HELP_DRAWER_SELECT_LAYER_CLASS } from '../../help-drawer.const'

import styles from '../../HelpDrawer.module.scss'

type Props = {
  feedbackTitle: string
  closeAriaLabel: string
  isHidden: boolean
  phase: ShareFeedbackPhase
  onSubmittingChange: (submitting: boolean) => void
  onSuccess: () => void
  onBack: () => void
}

export function HelpDrawerFeedbackView({
  feedbackTitle,
  closeAriaLabel,
  isHidden,
  phase,
  onSubmittingChange,
  onSuccess,
  onBack,
}: Props) {
  return (
    <div className={styles.view} data-testid={HELP_DRAWER_TEST_IDS.feedbackView} aria-hidden={isHidden}>
      <div className={styles.viewHeader}>
        <button
          type="button"
          className={styles.backButton}
          onClick={onBack}
          aria-label={closeAriaLabel}
          tabIndex={isHidden ? -1 : 0}
        >
          <IconComponent icon={Icon.ChevronLeftRegular} size={24} />
        </button>
        <p className={styles.viewTitle}>{feedbackTitle}</p>
        <div className={styles.headerDivider} />
      </div>

      <div className={styles.feedbackBody}>
        <ShareFeedbackContent
          phase={phase}
          onSubmittingChange={onSubmittingChange}
          onSuccess={onSuccess}
          hideTitle
          selectContentClassName={HELP_DRAWER_SELECT_LAYER_CLASS}
        />
      </div>
    </div>
  )
}
